const countNames = [
  'opened',
  'started',
  'paid',
  'pending',
  'failed',
  'abandoned',
  'blocked',
] as const;
type Counts = Record<(typeof countNames)[number], number>;
export type QrActivityReport = {
  asOf: string;
  since: string;
  trackingSince: string | null;
  truncated: boolean;
  totals: Counts;
  boxes: Array<
    Counts & {
      boxId: string;
      label: string;
      apartment: string | null;
      lastOpenedAt: string | null;
    }
  >;
  recentOpenings: Array<{ at: string; label: string }>;
};
const record = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);
const date = (value: unknown): value is string =>
  typeof value === 'string' && Number.isFinite(Date.parse(value));
const counts = (value: unknown): value is Counts & Record<string, unknown> =>
  record(value) &&
  countNames.every((key) => Number.isSafeInteger(value[key]) && Number(value[key]) >= 0);
export function isQrActivityReport(value: unknown): value is QrActivityReport {
  return (
    record(value) &&
    date(value.asOf) &&
    date(value.since) &&
    (value.trackingSince === null || date(value.trackingSince)) &&
    typeof value.truncated === 'boolean' &&
    counts(value.totals) &&
    Array.isArray(value.boxes) &&
    value.boxes.every(
      (box) =>
        record(box) &&
        counts(box) &&
        typeof box.boxId === 'string' &&
        box.boxId.length > 0 &&
        typeof box.label === 'string' &&
        (box.apartment === null || typeof box.apartment === 'string') &&
        (box.lastOpenedAt === null || date(box.lastOpenedAt)),
    ) &&
    Array.isArray(value.recentOpenings) &&
    value.recentOpenings.every(
      (opening) => record(opening) && date(opening.at) && typeof opening.label === 'string',
    )
  );
}
